import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Color } from '../../../config/Color';
import { SharedScreenName } from '../../../config/FlowTypes';
import { useAppStore } from '../../../store/Store';
import { useFlowNavigator } from '../../flows/FlowNavigation';
import { Body } from '../../styles/Typography';
import { formatSecondsRemainingAsTime, useCountdownTimer } from '../CheckoutInfo/CountdownTimer';
import { COUNTDOWN_FROM_SECONDS } from '../CheckoutInfo/ProductDetails';

/**
 * Control's 15-minute "program saved" countdown as one slim row. Like Control's, it sends the
 * person back to their results at zero, so callers don't render it on /start.
 */
export const HeldCountdown: FunctionComponent = () => {
  const navigation = useFlowNavigator();
  const paymentLoading = useAppStore((state) => state.purchase.payment.loading);
  const secondsRemaining = useCountdownTimer(COUNTDOWN_FROM_SECONDS, () => {
    // Leaving mid-payment unmounts the form that moves them on once the payment succeeds.
    if (!paymentLoading) {
      navigation.goTo(SharedScreenName.Results);
    }
  });

  return (
    <Bar data-test="countdownTimer">
      <Message>Your program is held for 15 minutes</Message>
      <Time>{formatSecondsRemainingAsTime(secondsRemaining)}</Time>
    </Bar>
  );
};

const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing._12px};
  min-height: 48px;
  padding: ${({ theme }) => `${theme.spacing._10px} ${theme.spacing._16px}`};
  border-radius: 14px;
  /* Pinned over the page as it scrolls: white, like the store card, so it reads over anything. */
  background: ${Color.subscription.accent};
  color: ${Color.state.select};
`;

const Message = styled(Body)`
  flex: 1;
  margin: 0;
  font-size: 14px;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: inherit;
  opacity: 0.7;
`;

const Time = styled(Body)`
  margin: 0;
  /* Circular's tabular figures look like a different font, so a fixed width stops the jiggle instead. */
  min-width: 5ch;
  text-align: right;
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: inherit;
`;
